<script>
import * as BABYLON from 'babylonjs'
import 'babylonjs-procedural-textures'

export default {
  name: 'Oeuvres',
  render: (h) => h(),
  data: () => ({
    nbActivated: 0,
    excluded: [ 'o_ANNIE_BAILLARGEON', 'o_CLAUDIE_GAGNON', 'o_JONAS_ST_MICHAEL', 'o_PATRICK_BERNATCHEZ', 'o_SKAWENNATI' ]
  }),
  beforeDestroy() {
    _.each(this.$cloneds, c => {
        c.dispose()
    })
  },
  beforeCreate() {

    this.$oeuvres = []
    this.$cloneds = []
    const scene = this.$parent.$scene
    const meshs = this.$parent.$meshs
    const oeuvres = this.$store.getters['app/oeuvres']

    // const posCamera = {
    //   o_MONNET_MAT_MR_oMONNET_0: {x: 61.846778112523076, y: 30, z: -122.84240688417536},
    //   o_DONG_MAT_MR_oDONG_0: {x: 44.21402207172982, y: 30, z: -124.14607806589099},
    //   o_BLAIN_MAT_MR_oBLAIN_0: {x: 141.01211943988164, y: 30, z: -74.79008651539675},
    //   o_GROOT_MAT_MR_oGROOT_0: {x: 160.79420371296843, y: 30, z: -211.3014528686651},
    //   o_ORTIZ_MAT_MR_oORTIZ_0: {x: -62.65655754523618, y: 30, z: -202.7255046488319},
    //   o_PAYETTE_MAT_MR_oPAYETTE_0: {x: -80.47134903720655, y: 30, z: -149.54913509062789},
    //   o_KIM_MAT_MR_oKIM_0: {x: 73.63870356545365, y: 30, z: -20.02561235068422}
    // }

    const posCamera = {

      o_ADAD_HANNAH: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
      o_ANNIE_BAILLARGEON: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
      o_CLAUDIE_GAGNON: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
      o_HUA_JIN: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
      o_JJ_LEVINE: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
      o_JONAS_ST_MICHAEL: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
      o_PATRICK_BERNATCHEZ: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
      o_SKAWENNATI: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
      o_MARISA_PORTOLESE: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
      o_MORIDJA_KITENGE_BANZA: { x: 61.846778112523076, y: 30, z: -122.84240688417536 },
    }

		_.each(posCamera, c => new BABYLON.Vector3(c.x, c.y, c.z))

    _.each(oeuvres, o => {

      const mesh = scene.getMeshByName(o.name)
			      mesh['cameraPos'] = posCamera[o.name]

      const matOriginal = new BABYLON.StandardMaterial(mesh.name + '_material', scene)
      // const textureOriginal = new BABYLON.Texture(o.image.sizes.medium, scene)

      if(mesh.material) {

        const textureOriginal = new BABYLON.Texture(mesh.material.albedoTexture.url, scene)
        matOriginal.diffuseTexture = textureOriginal
        matOriginal.emissiveTexture = textureOriginal
        matOriginal.backFaceCulling = false
        matOriginal.fogEnabled = false
        mesh.material = matOriginal
        mesh.isActive = false

      }

      const cloned = mesh.clone(mesh.name + '_clone')
      const matCloned = new BABYLON.StandardMaterial(mesh.name + '_clone_material', scene)
      const textureCloned = new BABYLON.Texture(o.image_blury.sizes.medium, scene)
      matCloned.diffuseTexture = textureCloned
      matCloned.emissiveTexture = textureCloned
      matCloned.backFaceCulling = false
      matCloned.fogEnabled = false
      matCloned.alpha = 0
      cloned.material = matCloned
      mesh.cloned = cloned

      const meshOverlay = mesh.clone(mesh.name + '_mesh_overlay')
      const overlayMat = new BABYLON.StandardMaterial(mesh.name + '_clone_overlay', scene)
      overlayMat.diffuseColor = new BABYLON.Color3(0, 0, 0)
      overlayMat.emissiveColor = new BABYLON.Color3(0, 0, 0)
      overlayMat.backFaceCulling = false
      overlayMat.fogEnabled = false
      meshOverlay.material = overlayMat
      overlayMat.alpha = 0
      mesh.overlay = meshOverlay

      this.$oeuvres.push(mesh)
      this.$cloneds.push(cloned)
    })

		this.$firstOeuvre = _.sampleSize(_.filter(this.$oeuvres, o => !o.isActive && o.cameraPos), 1)[0]
		const camera = this.$parent.$camera
		camera.position.x = this.$firstOeuvre.cameraPos.x
		camera.position.y = this.$firstOeuvre.cameraPos.y
		camera.position.z = this.$firstOeuvre.cameraPos.z
		camera.setTarget(this.$firstOeuvre.absolutePosition)  
  },


  computed: {
    oeuvre() {
      return _.find(this.$store.getters['app/oeuvres'], oeuvre  => oeuvre.is_active == true)
    },
    base_64() { return this.$store.getters['app/base_64'] },
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {

        if(this.slugIsAfter('9') && this.excluded.length > 3 || this.$route.meta.name == 'artwork')
          this.excluded = []

        if(this.slugIsIn(['defi1:1', 'defi1:2', 'defi2:1', 'defi2:2', 'defi2:3'])) {
          this.$nextTick(() =>{
            this.excluded.push(this.oeuvre.name)
          }) 
        }

        this.updateActived()

        // o_ADAD_HANNAH
        // o_HUA_JIN
        // o_JJ_LEVINE
        // o_MARISA_PORTOLESE
        // o_MARISA_PORTOLESE_02
        // o_MORIDJA_KITENGE_BANZA
        // o_MORIDJA_KITENGE_BANZA_02

        // o_ANNIE_BAILLARGEON
        // o_CLAUDIE_GAGNON
        // o_JONAS_ST_MICHAEL
        // o_PATRICK_BERNATCHEZ
        // o_SKAWENNATI
        
      }
    },
    base_64(nw, od) {
      let material = new BABYLON.StandardMaterial("texture", this.$parent.$scene)
          material.diffuseTexture = (navigator.maxTouchPoints == 5 || this.$root.$agent.tablet) 
          ? new BABYLON.Texture(require('./img/portrait_'+ this.lang +'.png'), this.$parent.$scene)
          : new BABYLON.Texture(nw, this.$parent.$scene)
          material.diffuseTexture.uScale = 1.50 * 1.02
          material.diffuseTexture.vScale = 1.06 * 1.01
          material.backFaceCulling = false     
      let owner = this.$parent.$scene.getMeshByName('o_Vitre')
          owner.material = material
    },
  },
  methods: {
    updateActived() {
      if(this.slugIsBefore('0'))
          return
      this.$nextTick(() =>{
        _.each(this.$oeuvres, (o)=>{
          o.isActive = false
        })
        _.each(this.$oeuvres, (o)=>{
          if(_.indexOf(this.excluded, o.name) == -1) {
            o.isActive = true
            TweenMax.to(o.material, 10, { alpha:  1 })
            TweenMax.to(o.cloned.material, 10, { alpha: 0 })
            TweenMax.to(o.overlay.material, 10, { alpha: 0 })
          }
        })
        _.each(this.$oeuvres, o => {
          if(!o.isActive) {
            TweenMax.to(o.material, 1, { alpha: 0 })
            TweenMax.to(o.cloned.material, 1, { alpha: 1 })
            TweenMax.to(o.overlay.material, 1, { alpha: .8 })
          }
        })
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/world/elements/Oeuvres.vue